import styled from '@emotion/styled';

const H1 = styled.h1`
  margin: 0;
  font-family: 'FrankRuhLibre, serif';
  font-size: 30px;
  line-height: 38px;

  @media (min-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
    font-size: 48px;
    line-height: 60px;
  }
`;

const H2 = styled.h2`
  margin: 0;
  font-size: 22px;
  line-height: 32px;

  @media (min-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
    font-size: 36px;
    line-height: 48px;
  }
`;

const H3 = styled.h3`
  margin: 0;
  font-size: 18px;
  line-height: 32px;

  @media (min-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
    font-size: 24px;
    line-height: 32px;
  }
`;

const B1 = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 22px;

  @media (min-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
    font-size: 22px;
    line-height: 34px;
  }
`;

const B2 = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 24px;

  @media (min-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
    font-size: 18px;
    line-height: 30px;
  }
`;

const C1 = styled.p`
  margin: 0;
  font-size: 12px;
  line-height: 24px;

  @media (min-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
    font-size: 16px;
    line-height: 28px;
  }
`;

export const StyledTypography = {
  H1,
  H2,
  H3,
  B1,
  B2,
  C1,
};
